<template>
  <div class="loading">
    <!-- @todo temp. -->
    <i class="fa-solid fa-sharp fa-spin fa-loader"></i>
  </div>
</template>

<script>
export default {
  name: 'loading',
};
</script>
